import { render, staticRenderFns } from "./PprNoPopupSearch.vue?vue&type=template&id=065dfe12&"
import script from "./PprNoPopupSearch.vue?vue&type=script&lang=js&"
export * from "./PprNoPopupSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports